import React from 'react';
import { Episode } from '../types/types';

interface EpisodeProps {
  episode: Episode;
}

const EpisodeCard: React.FC<EpisodeProps> = ({ episode }) => {
  const { number, title, date, duration, thumbnailId, videoId } = episode;
  
  const handleClick = () => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };
  
  return (
    <div className="episode-card" onClick={handleClick}>
      <div className="video-container">
        <img 
          src={`https://img.youtube.com/vi/${thumbnailId || videoId}/maxresdefault.jpg`}
          alt={`${title} Thumbnail`}
          loading="lazy"
          decoding="async"
          width="1280"
          height="720"
          style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
        />
      </div>
      <div className="episode-info">
        <span className="episode-number">{number}</span>
        <h3 className="episode-title">{title}</h3>
        <div className="episode-meta">
          <span className="episode-date">{date}</span>
          <span className="episode-duration">{duration}</span>
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard; 